export enum NotificationRecipient {
  ALL = "ALL",
}
